import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forYou = ['Busy parents 25-65 tired of pharmacy bills', 'Health-conscious Americans wanting kitchen first-aid', 'Anyone experiencing: colds, pain, sleep issues, digestion, stress', 'Families wanting natural before meds (90% of ailments)', "People who've tried Google/supplements and failed"];
const notForYou = ['Seeking medical diagnosis/treatment', 'Severe chronic illness (cancer, autoimmune)', "People wanting 'magic pills' vs kitchen work", 'Non-English readers', 'Those unwilling to stock 10 basic herbs'];
export function WhoIsFor() {
  return <section className="py-20 bg-[#f4f7f5]" data-id="element-214">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-215">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-216">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#1a3c2a]" data-id="element-217">
            <h3 className="text-2xl font-bold text-[#1a3c2a] mb-6 flex items-center gap-3" data-id="element-218">
              <span className="bg-[#e8f5e9] p-2 rounded-full" data-id="element-219">
                <Check className="w-6 h-6 text-[#1a3c2a]" data-id="element-220" />
              </span>
              This Is For You If...
            </h3>
            <ul className="space-y-4" data-id="element-221">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-222">
                  <Check className="w-5 h-5 text-[#1a3c2a] mt-1 shrink-0" data-id="element-223" />
                  <span className="text-[#5c4a32]" data-id="element-224">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#fafafa] p-8 rounded-2xl shadow-inner border-t-4 border-gray-300" data-id="element-225">
            <h3 className="text-2xl font-bold text-gray-600 mb-6 flex items-center gap-3" data-id="element-226">
              <span className="bg-gray-200 p-2 rounded-full" data-id="element-227">
                <X className="w-6 h-6 text-gray-600" data-id="element-228" />
              </span>
              This Is NOT For You If...
            </h3>
            <ul className="space-y-4" data-id="element-229">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-230">
                  <X className="w-5 h-5 text-gray-400 mt-1 shrink-0" data-id="element-231" />
                  <span className="text-gray-500" data-id="element-232">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}